/**************************************************
 * Nombre:       Formulario_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    Flag,
    FlagOutlined,
    Mail,
    MapsHomeWorkOutlined,
    SignpostOutlined,
    SmartphoneOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Pedido from "./Formulario_Producto_Pedido";
import Tarjetas_Producto from "../Tarjeta/Tarjetas_Producto";
import {useEffect, useState} from "react";
import {obtenerTotal} from "../../CodNegocio/obtenerTotal";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {ESTADOSPEDIDOS} from "../../Constantes";

const Formulario_Pedido = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'productos',
        Formulario: Formulario_Producto_Pedido,
        nombre: 'Actualizar',
        Tarjeta: Tarjetas_Producto
    })
    const [valor, setValor] = useState(0)
    const [valorEnvio, setValorEnvio] = useState(0)


    useEffect(() => {



        let entidad = props.props.getValues()
        let productos = props.props.getValues('productos')
        let val = obtenerTotal(productos)
        if (val) {
            setValor(val)
        }
        setValorEnvio(entidad.valorEnvio)

    }, [props.props.watch('productos')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSPEDIDOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-end', alignItems: 'center'}}
                spacing={0}
                >
                    <Typography
                        sx={{fontSize: 14, fontWeight: 800}}>{`Valor Pedido: ${formatoMonedaTabla(valor)}`}</Typography>
                    <Typography
                        sx={{fontSize: 14, fontWeight: 600}}>{`Valor Envio: ${formatoMonedaTabla(valorEnvio)}`}</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos Cliente</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}/>
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificación'} dato={'cc'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Productos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Flag} nombre={'Provincia'}
                                   dato={'provincia'} {...props}
                                   requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Barrio o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Dirección'} dato={'direccion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Indicaciones adiciónales'} dato={'indicaciones'} {...props} />
                </Grid>



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Notas Internas</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Notas Internas'} dato={'notas'} {...props} />
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Pedido